module.exports = __webpack_public_path__ + "static/media/jacobs.8f3e8ccb.png";